import React, { useState } from 'react';
import {
  Box,
  Divider,
  Tab,
  Tabs,
  Typography,
  Paper,
  Stack,
  alpha,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  AssessmentOutlined,
  PaymentsOutlined,
  HistoryToggleOffOutlined,
  ChevronRight,
  BarChartOutlined,
  DescriptionOutlined,
  ListAltOutlined,
  EmailOutlined,
  AnalyticsOutlined,
  AutoAwesomeOutlined,
  ReceiptLongOutlined,
} from '@mui/icons-material';

import FacilityAnalyticsReport from './reports/FacilityAnalytics';
import EmailLogs from './activities/EmailLogs';
import AuditLogs from './activities/AuditLogs';
import PaymentReports from './payments/PaymentReport';
import InvoiceReports from './payments/InvoiceReport';
import { userCats } from '../../../helpers/appstate';
import DiscussionReport from './reports/DiscussionReport';
import CategoryAnalytics from './reports/CategoryAnalytics';
import ScheduleAnalytics from './reports/ScheduleAnalytics';
import TestReport3 from './reports/TestReport3';
import BasicFacilityReport from './reports/BasicFacilityReport';
import CrossFacilityAnalytics from './reports/CrossFacilityAnalytics';
import GeographicalSpatialAnalytics from './reports/GeographicalSpatialAnalytics';
import RegulatoryAuditReport from './reports/RegulatoryAuditReport';
import AnalyticalReport from './reports/AnalyticalReport';
import AnalyticalReport2 from './reports/AnalyticalReport2';
import LgaFacilityReports from './reports/LgaFacilityReports';
import LgaSectorReport from './reports/LgaSectorReport';
import SectorReport from './reports/SectorReport';
import QuarterlyComparisonReport from './reports/QuarterlyComparisonReport';
import AiReport from './reports/AiReport';

export default function ReportingScreen({ props }) {
  const { userCategory, userPermission } = props;
  const permissions = userPermission?.map((i) => i.toLowerCase()) || [];

  const canViewActivityReports = permissions.includes('activity_reports');
  const canViewMonitoringReports = permissions.includes('monitoring_reports');
  const canViewPaymentReports = permissions.includes('payment_reports');

  const items1 = [
    {
      key: '1',
      label: 'Basic Report',
      children: <BasicFacilityReport props={props} />,
      visible: userCategory === userCats.EDM || userCategory === userCats.REGULATOR,
    },
    
    // {
    //   key: '2',
    //   label: 'Analytical Report',
    //   icon: <DescriptionOutlined fontSize="small" />,
    //   children: <AnalyticalReport props={props} />,
    //   visible: userCategory === userCats.EDM || userCategory === userCats.REGULATOR,
    // },

    {
      key: '2',
      label: 'Analytical Report',
      icon: <DescriptionOutlined fontSize="small" />,
      children: <AnalyticalReport2 props={props} />,
      visible: userCategory === userCats.EDM || userCategory === userCats.REGULATOR,
    },

    // {
    //   key: '2',
    //   label: 'Quarterly Report - Analytics',
    //   children: <FacilityAnalyticsReport props={props} />,
    //   visibile:true
    // },
    {
      key: '3',
      label: 'Discussion Report',
      children: <DiscussionReport props={props} />,
      visible: true,
    },
    {
      key: '4',
      label: 'Category Analytics',
      children: <CategoryAnalytics props={props} />,
      visible: userCategory === userCats.EDM || userCategory === userCats.REGULATOR,
    },

    {
      key: '5',
      label: 'Sector Analytics',
      children: <CrossFacilityAnalytics props={props} />,
      visible: userCategory === userCats.EDM || userCategory === userCats.REGULATOR,
    },

    {
      key: '6',
      label: 'LGA Facility Reports',
      children: <LgaFacilityReports props={props} />,
      visible: userCategory === userCats.EDM || userCategory === userCats.REGULATOR,
    },

    {
      key: '7',
      label: 'LGA Sector Reports',
      children: <LgaSectorReport props={props} />,
      visible: userCategory === userCats.EDM || userCategory === userCats.REGULATOR,
    },

    {
      key: '8',
      label: 'Sector Category Reports',
      children: <SectorReport props={props} />,
      visible: userCategory === userCats.EDM || userCategory === userCats.REGULATOR,
    },

    {
      key: '9',
      label: 'Quarterly Comparison Reports',
      children: <QuarterlyComparisonReport props={props} />,
      visible: userCategory === userCats.EDM || userCategory === userCats.REGULATOR,
    },

    // {
    //   key: 'ai-report',
    //   label: 'AI Reports',
    //   icon: <AutoAwesomeOutlined fontSize="small" />,
    //   children: <AiReport />,
    //   visible: true,
    // },  

    // {
    //   key: '6',
    //   label: 'Geographical Analytics',
    //   children: <GeographicalSpatialAnalytics props={props} />,
    //   visible: userCategory === userCats.EDM || userCategory === userCats.REGULATOR,
    // },

    // {
    //   key: '7',
    //   label: 'Limits Analytics',
    //   children: <RegulatoryAuditReport props={props} />,
    //   visible: userCategory === userCats.EDM || userCategory === userCats.REGULATOR,
    // },

    // {
    //   key: '5',
    //   label: 'Schedule Analytics',
    //   children: <ScheduleAnalytics props={props} />,
    //   visible: userCategory === userCats.EDM || userCategory === userCats.REGULATOR,
    // },
    // {
    //   key: '6',
    //   label: 'Result Summary',
    //   children: <TestReport3 />,
    //   visible: userCategory === userCats.EDM || userCategory === userCats.REGULATOR,
    // },
  ];

  const items2 = [
    {
      key: '1',
      label: 'QA/QC Payments',
      icon: <PaymentsOutlined fontSize="small" />,
      children: <PaymentReports />,
      visible: true, // Added visible property for consistency
    },
    {
      key: '2',
      label: 'QA/QC Invoices',
      icon: <ReceiptLongOutlined fontSize="small" />,
      children: <InvoiceReports />,
      visible: true,
    },
  ];

  const items3 = [
    {
      key: '1',
      label: 'Audit Log',
      icon: <ListAltOutlined fontSize="small" />,
      children: <AuditLogs />,
      visible: true, // Added visible property for consistency
    },
    {
      key: '2',
      label: 'Email log',
      icon: <EmailOutlined fontSize="small" />,
      children: <EmailLogs />,
      visible: true, // Added visible property for consistency
    },
  ];

  const menus = [
    {
      key: 1,
      label: 'Monitoring',
      icon: <AssessmentOutlined />,
      // Only include children that are marked as visible
      children: items1.filter((i) => i.visible),
      visible:
        userCategory === userCats.PERSONNEL ||
        userCategory === userCats.CONSULTANT || // Fixed standing logic error here
        canViewMonitoringReports,
    },
    {
      key: 2,
      label: 'Financial',
      icon: <PaymentsOutlined />,
      children: items2.filter((i) => i.visible),
      visible: canViewPaymentReports,
    },
    {
      key: 3,
      label: 'Activity',
      icon: <HistoryToggleOffOutlined />,
      children: items3.filter((i) => i.visible),
      visible: canViewActivityReports,
    },
  ].filter((i) => i.visible);

  const [currentTab, setCurrentTab] = useState(0);
  const [sideTab, setSideTab] = useState(0);

  const activeMenu = menus[currentTab];
  // We use the filtered children from activeMenu
  const activeChild = activeMenu?.children?.[sideTab];

  return (
    <Box
      sx={{
        //p: { xs: 1, md: 2 },
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
            flexDirection: 'column',
          }}
        >

      <Paper
        elevation={0}
        sx={
          {
            //borderRadius: '16px 16px 0 0',
            //border: '1px solid',
            //borderColor: 'divider',
            //borderBottom: 'none',
          }
        }
      >
        <Tabs
          value={currentTab}
          onChange={(_, val) => {
            setCurrentTab(val);
            setSideTab(0);
          }}
          sx={{
            //px: 2,
            '& .MuiTabs-indicator': { height: 3, borderRadius: '3px 3px 0 0' },
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 700,
              fontSize: '0.9rem',
              minHeight: 60,
              color: 'text.secondary',
              '&.Mui-selected': { color: 'primary.main' },
            },
          }}
        >
          {menus.map((menu) => (
            <Tab
              key={menu.key}
              label={menu.label}
              icon={menu.icon}
              iconPosition="start"
              sx={{ minWidth: 160 }}
            />
          ))}
        </Tabs>
      </Paper>

      {/* CONTENT AREA WITH SIDEBAR */}
      <Paper
        elevation={0}
        sx={{
          flexGrow: 1,
          display: 'flex',
          borderRadius: '0 0 16px 16px',
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
          bgcolor: '#fff',
        }}
      >
        {activeMenu && (
          <>
            {/* SUB-MENU SIDEBAR - Now only maps visible children */}
            <Box
              sx={{
                width: 220,
                borderRight: '1px solid',
                borderColor: 'divider',
                bgcolor: alpha('#F4F6F8', 0.4),
                py: 2,
              }}
            >
              <List sx={{ px: 1 }}>
                {activeMenu.children.map((item, index) => (
                  <ListItemButton
                    key={item.key}
                    selected={sideTab === index}
                    onClick={() => setSideTab(index)}
                    sx={{
                      borderRadius: 3,
                      mb: 0.5,
                      py: 0.8,
                      px: 3,
                      '&.Mui-selected': {
                        bgcolor: alpha('#1976d2', 0.08),
                        color: 'primary.main',
                        '&:hover': { bgcolor: alpha('#1976d2', 0.12) },
                        '& .MuiListItemIcon-root': { color: 'primary.main' },
                      },
                    }}
                  >
                    {/* <ListItemIcon sx={{ minWidth: 36, color: 'text.secondary' }}>
                      {item.icon || <AnalyticsOutlined fontSize="small" />}
                    </ListItemIcon> */}
                    <ListItemText
                      primary={item.label}
                      primaryTypographyProps={{
                        fontSize: '0.8rem',
                        ml: -1,
                        fontWeight: sideTab === index ? 700 : 500,
                      }}
                    />
                    {/* {sideTab === index && <ChevronRight fontSize="small" />} */}
                  </ListItemButton>
                ))}
              </List>
            </Box>

            {/* MAIN DATA VIEW */}
            <Box sx={{ flex: 1, overflowY: 'auto' }}>
              {activeChild ? (
                activeChild.children
              ) : (
                <Stack
                  alignItems="center"
                  justifyContent="center"
                  sx={{ height: '100%', color: 'text.disabled' }}
                >
                  <AssessmentOutlined sx={{ fontSize: 48, mb: 1, opacity: 0.5 }} />
                  <Typography variant="body2">Select a report view from the sidebar.</Typography>
                </Stack>
              )}
            </Box>
          </>
        )}
      </Paper>
    </Box>
  );
}
